import React from 'react';
import IncomePage from '../../income/components/IncomePage';

const IncomeSection = ({ isPartnerMode, isOurMode, partnerName }) => {
  return <IncomePage isPartnerMode={isPartnerMode} isOurMode={isOurMode} partnerName={partnerName} />;
};

export default IncomeSection; 